export enum FilterActionTypes {
  UPDATE_FILTERS = "UPDATE_FILTERS",
  UPDATE_SELECTED_FILTERS = "UPDATE_SELECTED_FILTERS",
  UPDATE_TITLE_SUBSTRING_FILTER = "UPDATE_TITLE_SUBSTRING_FILTER",
  PERFORM_SEARCH = "PERFORM_SEARCH",
}
